import React, { useState, useEffect } from 'react';
import { farmDataByGreenhouse } from './farmData';
import styled from 'styled-components';
import CountUp from 'react-countup';  // react-countupをインポート

const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto 20px;
  gap: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
  }
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 15px;
  padding: 10px 0;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Value = styled.div`  
    font-size: 2.5vw;  
    color: ${({ color }) => color || 'black'};  
    font-weight: bold;  
    margin-bottom: 5px; /* 数値の下に余白を追加 */
    @media (max-width: 768px) {  
        font-size: 8vw;  
    }  
`;

const LabelOverlay = styled.div`  
    font-size: 1.2rem; /* フォントサイズを少し小さく */
    color: #666666; /* ラベルの色を少し落ち着いた色に変更 */
    margin-top: 5px;  
    @media (max-width: 768px) {  
        font-size: 4vw;  
    }  
`;

const PercentageValue = styled.span`  
  color: green; /* ここで色を指定 */  
  font-weight: bold;  
`;

const HarvestSummary = ({ greenhouse, areaInR, regionalavg, size}) => {
  const [data, setData] = useState({ totalWeight: 0, yieldPer10R: 0 });

  useEffect(() => {
    if (!greenhouse || !areaInR) return;

    const greenhouseData = farmDataByGreenhouse[greenhouse] || [];
    const totalWeight = greenhouseData.reduce((sum, item) => sum + item.weight, 0);

    const yieldPer10R = areaInR > 0 ? (totalWeight / 1000) / (areaInR / 10) : 0;
    setData({ totalWeight, yieldPer10R });
  }, [greenhouse, areaInR]);

  return (
    <Container>
      <Card>
        <Value color="Green" >
          <CountUp
            end={(data.totalWeight / 1000).toFixed(1)}
            decimals={1}
            suffix="t"
            duration={2}  // アニメーションの長さを設定
          />
        </Value>
        <LabelOverlay>年間総収量{size}a</LabelOverlay>
      </Card>
      <Card>
        <Value color="Green" >
          <CountUp
            end={data.yieldPer10R.toFixed(1)}
            decimals={1}
            suffix="t"
            duration={2}  // アニメーションの長さを設定
          />
        </Value>
        <LabelOverlay>反収 対平均
          <PercentageValue>
          <CountUp
            end={((data.yieldPer10R.toFixed(1) / regionalavg - 1) * 100).toFixed(1)}
            decimals={1}
            suffix="%"
            duration={2}  // アニメーションの長さを設定
          />
          </PercentageValue>
          UP
        </LabelOverlay>
      </Card>
    </Container>
  );
};

export default HarvestSummary;
